/**
 * One global queue for everything the pane does to the document (spec §5.2 "one apply in flight").
 * A failed task never blocks the tasks behind it.
 */
export class TaskQueue {
  private tail: Promise<unknown> = Promise.resolve();
  private pending = 0;

  /** Number of tasks queued or running. */
  get size(): number {
    return this.pending;
  }

  run<T>(task: () => Promise<T>): Promise<T> {
    this.pending++;
    const result = this.tail.then(task, task);
    this.tail = result.then(
      () => undefined,
      () => undefined,
    );
    return result.finally(() => {
      this.pending--;
    });
  }
}

/** The pane-wide queue shared by every hands instance. */
export const documentQueue = new TaskQueue();
